import { useState } from 'react'
import Button from '@/components/common/Button'
import Badge from '@/components/common/Badge'
import { getAgeGroupLabel } from '@/lib/hockeyData'

/**
 * PersonalizedHeader Component
 * 
 * Displays "Scrimmage opportunities for [Team Name]" when a team profile is loaded.
 * Shows the team name prominently so users know which team they're viewing as.
 */
export default function PersonalizedHeader({ 
  teamProfile, 
  resultsCount, 
  isPersonalized, 
  onTogglePersonalized,
  loading 
}) {
  if (!teamProfile || !teamProfile.team_name) {
    return null
  }

  return (
    <div className="bg-white border border-border rounded-lg p-4 mb-4 shadow-sm">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-10 h-10 bg-brand-green rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-lg">
              {teamProfile.team_name.charAt(0)}
            </span>
          </div>
          <div>
            <h2 className="font-heading text-lg font-bold text-brand-charcoal">
              {loading ? (
                'Finding opportunities...'
              ) : isPersonalized ? (
                <>
                  <span className="text-brand-green">{resultsCount}</span>
                  {' '}opportunit{resultsCount !== 1 ? 'ies' : 'y'} for <span className="text-brand-green">{teamProfile.team_name}</span>
                </>
              ) : (
                <>
                  All scrimmages for <span className="text-brand-green">{teamProfile.team_name}</span>'s level
                </>
              )}
            </h2>
            <div className="flex flex-wrap items-center gap-2 mt-1">
              {teamProfile.team_level && (
                <Badge variant="info">
                  {getAgeGroupLabel(teamProfile.team_level) || teamProfile.team_level}
                  {teamProfile.team_level_detail && ` ${teamProfile.team_level_detail}`}
                </Badge>
              )}
              {isPersonalized && teamProfile.preferred_radius_miles && (
                <Badge variant="default">
                  Within {teamProfile.preferred_radius_miles}mi
                </Badge>
              )}
            </div>
          </div>
        </div>

        {/* Only show toggle when in personalized mode - to switch to "all" view */}
        {isPersonalized && (
          <Button
            variant="outline"
            size="sm"
            onClick={onTogglePersonalized}
          >
            Show all scrimmages
          </Button>
        )}
      </div>

      {isPersonalized && teamProfile.has_profile === false && (
        <div className="mt-3 pt-3 border-t border-border">
          <p className="text-sm text-brand-slate">
            💡 <strong>Tip:</strong> Set up your team profile to customize your preferred radius, 
            referee type, and other preferences for better matches.
          </p>
        </div>
      )}
    </div>
  )
}
